import { useBreakpointValue } from '@chakra-ui/react';

/**
 * Keyboard focus on the dark frame. The recipes ring in charcoal, which vanishes
 * on charcoal, so every control of the frame takes this light outline instead.
 */
export const NAV_DARK_FOCUS_RING = {
  outline: '2px solid',
  outlineColor: 'navDark.focusBorder',
  outlineOffset: '0',
  boxShadow: 'none',
} as const;

/**
 * Whether the frame renders its phone layout (no menu, flush content). It reads
 * the real viewport on the first render: this app has no server render to match,
 * and Chakra's default answers "phone" first, which mounted the content at x=0
 * and slid it under the menu on every mount of the layout.
 */
export const useIsMobileLayout = (): boolean =>
  useBreakpointValue({ base: true, md: false }, { ssr: false }) ?? false;
